// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host, .layout-content {
  width: 100%;
  background-color: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/shared/containers/layout/layout.container.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,yBAAA;AADJ","sourcesContent":["@import '../../../assets/sass/colors';\n\n:host, .layout-content {\n    width: 100%;\n    background-color: primary-palette(100-white);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
